import React from "react";

const Pricing = () => {
  return (
    <section className="pricing-section">
      <div className="container">
        <div className="heading">
          <span className="sub-heading">🚀 Beta Version</span>
          <h2 className="title">Exclusive Early Access for Just $10</h2>
          <p className="description">
            We're in beta! Get lifetime access to all premium features at this low price before it increases.
          </p>
        </div>

        <div className="pricing-cards">
          <PricingCard
            type="Lifetime Access (Beta)"
            price="$10.99"
            description="Unlock lifetime access to all premium features and updates during our beta phase."
            buttonText="Get Early Access"
            active
          >
            <List>✅ Unlimited Job Searches</List>
            <List>✅ Unlimited Connection Scans</List>
            <List>✅ Instant Referral Insights</List>
            <List>✅ Automated Matchmaking</List>
            <List>✅ Advanced Job Filters</List>
            <List>✅ Direct Connection Outreach</List>
            <List>✅ Priority Support</List>
            <List>✅ Future Feature Updates</List>
            <List>✅ Privacy First – Your data stays with you</List>
          </PricingCard>
        </div>
      </div>
    </section>
  );
};

const PricingCard = ({
  children,
  description,
  price,
  type,
  subscription,
  buttonText,
  active,
}) => {
  return (
    <div className={`pricing-card ${active ? "active" : ""}`}>
      <span className="card-type">{type}</span>
      <h2 className="card-price">
        {price}
        <span className="card-subscription">{subscription}</span>
      </h2>
      <p className="card-description">{description}</p>
      <div className="card-features">{children}</div>
      <button className={`card-button ${active ? "active" : ""}`}>
        {buttonText}
      </button>
    </div>
  );
};

const List = ({ children }) => {
  return <div className="card-list">{children}</div>;
};

export default Pricing;
